var _rect, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRedirectButtonIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.75,
    y: 0.75,
    width: 40.4961,
    height: 40.4961,
    rx: 20.248,
    stroke: "#660033",
    strokeWidth: 1.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.8291 14.0977C27.9387 14.0977 28.0373 14.1381 28.1162 14.2148L28.124 14.2227C28.2065 14.3056 28.2497 14.4116 28.248 14.5312L28.1719 20.0186C28.1709 20.0778 28.1356 20.125 28.0879 20.1445C28.0406 20.1638 27.9869 20.154 27.9482 20.1152L26.7598 18.918L26.2275 18.3828L25.6953 18.918L20.7939 23.8545C20.6767 23.9725 20.5255 24.0342 20.3623 24.0342C20.1996 24.0342 20.0492 23.9728 19.9316 23.8545L18.5713 22.4844V22.4834L18.4922 22.3867C18.3344 22.1455 18.3603 21.814 18.5713 21.6016L23.4727 16.666L23.998 16.1377L23.4727 15.6094L22.2832 14.4111C22.2446 14.3713 22.2325 14.312 22.2539 14.2588C22.2758 14.2046 22.3233 14.1754 22.3721 14.1748H22.373L27.8232 14.0977H27.8291Z",
    fill: "#660033",
    stroke: "#660033",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9602 29.4573H15.6474C14.1878 29.4573 13 28.2612 13 26.7916V18.4216C13 16.9519 14.1879 15.7559 15.6474 15.7559H18.8178C19.2598 15.7559 19.6185 16.117 19.6185 16.5621C19.6185 17.0072 19.2598 17.3683 18.8178 17.3683H15.6474C15.0703 17.3683 14.6006 17.8414 14.6006 18.4224V26.7924C14.6006 27.3735 15.0703 27.8465 15.6474 27.8465H23.9596C24.5367 27.8465 25.0064 27.3735 25.0064 26.7924V23.5999C25.0064 23.1549 25.3651 22.7937 25.8071 22.7937C26.2491 22.7937 26.6078 23.1549 26.6078 23.5999V26.7924C26.6078 28.2621 25.4197 29.4573 23.9602 29.4573Z",
    fill: "#660033"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedirectButtonIcon);
export default __webpack_public_path__ + "static/media/Redirect_ButtonIcon.159ded6f1d728d449986a367a31a20b6.svg";
export { ForwardRef as ReactComponent };